// extracted by mini-css-extract-plugin
export default {"centered-error":"CenteredErrorMessage_centered-error__V9zcy"};